import { AssetNames } from "@utils/types";
import { WeaponType, BaseCharacterGender, WeaponTexture } from "mmo-common";
import { Vector3 } from "realms-engine";

export interface WeaponTextureAssetConfig {
  asset: AssetNames;
  transparent?: boolean;
}

export const WEAPON_TEXTURE_ASSET_MAPPING: {
  [weaponType in WeaponType]: {
    [texture in WeaponTexture<weaponType>]: WeaponTextureAssetConfig;
  };
} = {
  [WeaponType.Sword]: {
    hero: {
      asset: "swordHeroTexture",
    },
  },
  [WeaponType.Dagger]: {
    rogue: {
      asset: "daggerRogueTexture",
    },
  },
  [WeaponType.Staff]: {
    mage: {
      asset: "staffMageTexture",
    },
  },
};

export const WEAPON_ASSET_MAPPING: {
  [w in WeaponType]: {
    asset: AssetNames;
    transformation: {
      [g in BaseCharacterGender]: {
        position: Vector3;
        rotation: Vector3;
      };
    };
  };
} = {
  [WeaponType.Sword]: {
    asset: "sword",
    transformation: {
      [BaseCharacterGender.Male]: {
        position: {
          x: -650,
          y: 300,
          z: 20,
        },
        rotation: {
          x: 0,
          y: Math.PI / 2,
          z: 0,
        },
      },
      [BaseCharacterGender.Female]: {
        position: {
          x: -650,
          y: 300,
          z: 110,
        },
        rotation: {
          x: 0,
          y: Math.PI / 2,
          z: 0,
        },
      },
    },
  },
  [WeaponType.Dagger]: {
    asset: "dagger",
    transformation: {
      [BaseCharacterGender.Male]: {
        position: {
          x: 450,
          y: 300,
          z: 20,
        },
        rotation: {
          x: 0,
          y: -Math.PI / 2,
          z: 0,
        },
      },
      [BaseCharacterGender.Female]: {
        position: {
          x: 450,
          y: 300,
          z: 110,
        },
        rotation: {
          x: 0,
          y: -Math.PI / 2,
          z: 0,
        },
      },
    },
  },
  [WeaponType.Staff]: {
    asset: "staff",
    transformation: {
      [BaseCharacterGender.Male]: {
        position: {
          x: -3850,
          y: 300,
          z: 20,
        },
        rotation: {
          x: 0,
          y: Math.PI / 2,
          z: 0,
        },
      },
      [BaseCharacterGender.Female]: {
        position: {
          x: -3850,
          y: 300,
          z: 110,
        },
        rotation: {
          x: 0,
          y: Math.PI / 2,
          z: 0,
        },
      },
    },
  },
};
